import type { FunnelStage } from '../types/contracts';

export function buildFunnel(counts: Record<string, number>): FunnelStage[] {
  const order = [
    ['conversations', 'Conversations'],
    ['leads', 'Leads'],
    ['qualified', 'Qualified'],
    ['interested', 'Interested'],
    ['demo_trial', 'Demo / Trial'],
    ['paid', 'Paid'],
  ] as const;
  let previous: number | null = null;
  return order.map(([key, label]) => {
    const count = Math.max(0, counts[key] ?? 0);
    let conversion_from_previous: number | null = null;
    let dropoff_from_previous: number | null = null;
    if (previous !== null) {
      conversion_from_previous = previous > 0 ? Math.round((count / previous) * 1000) / 10 : 0;
      dropoff_from_previous = previous > 0 ? Math.round((1 - count / previous) * 1000) / 10 : 0;
    }
    previous = count;
    return { key, label, count, conversion_from_previous, dropoff_from_previous };
  });
}
